import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {JirasulInfo, PoiDeployedVersionService} from './poi-deployed-version.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-poi-deployed-version',
    templateUrl: './poi-deployed-version.component.html',
    styleUrls: ['./poi-deployed-version.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class PoiDeployedVersionComponent implements OnInit{

  private info: JirasulInfo;

  constructor(
    private poiDeployedVersionService: PoiDeployedVersionService,
    private notificationService: ToastrService,
  ) {

  }

  ngOnInit(): void {
    this.poiDeployedVersionService.getInfo().subscribe({
      next: res => {
        this.info = res;
        this.notificationService.success('updated data');
      },
      error: err => this.notificationService.error('failed to get jirasul data', err),
    });
  }

  getColumns(): string[] {
    if (!this.info) {
      return [];
    }
    return ['CD', 'ACC', 'DEV', 'QA_P1', 'QA_P2', 'QA_MASS', 'PROD_P1', 'PROD_P2', 'PROD_MASS'];
  }

  getRows(): string[] {
    if (!this.info) {
      return [];
    }

    return this.info.modules;
  }

  refresh() {
    this.ngOnInit();
  }

  getVersion(stage: string, module: string): string {
    const ourModule = this.info.currentVersion[module];
    if (!ourModule) {
      return '';
    }
    const ourStage = ourModule[stage];
    if (!ourStage) {
      return '';
    }
    const technicalVersion = ourStage.seenVersion;
    if (!technicalVersion) {
      return '';
    }

    const marketingVersion = this.info.toMarketingVersions[technicalVersion];
    if (marketingVersion) {
      return `${technicalVersion} (${marketingVersion})`;
    }
    return technicalVersion;
  }

  getGitCommit(stage: string, module: string): string {
    const ourModule = this.info.currentState[module];
    if (!ourModule) {
      return '';
    }
    const ourStage = ourModule[stage];
    if (!ourStage) {
      return '';
    }
    return `${ourStage.commit}\n(${ourStage.date})`;
  }
}
